// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import VueCordova from 'vue-cordova'
import Vuetify from 'vuetify'
import axios from 'axios'
import store from './vuex'
import router from './router'
import './auth'
import { sync } from 'vuex-router-sync'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import VueTheMask from 'vue-the-mask'
import * as VueGoogleMaps from 'vue2-google-maps'
import VueImg from 'v-img'
import { hasCustomPermissionsPayload, shouldUseCustomPermissions, hasGeneralAccess, hasGranularPermission } from './utils/access'
import { getUserRestrictionFlag, primeUserRestrictions } from './utils/roleRestrictions'

sync(store, router)

// Initialize Cordova
Vue.use(VueCordova)
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script')
  cordovaScript.setAttribute('type', 'text/javascript')
  cordovaScript.setAttribute('src', 'cordova.js')
  document.body.appendChild(cordovaScript)
}

Vue.use(Vuetify)
Vue.use(VueImg)

Vue.use(VueTheMask)

Validator.addLocale(ptBR)
Vue.use(VeeValidate, {
  locale: 'pt_BR'
})

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBeoZfZPWSQP49sEuM5SdjrJ3ne5qInXxY',
    libraries: 'places, geometry'
  }
})

Vue.mixin({
  methods: {
    $hasGeneralAccess (permissionKey) {
      const user = this.$auth.user()
      if (!user) return false

      // 1. Prioritize custom RBAC payload when present (fail-closed).
      if (shouldUseCustomPermissions(user)) {
        return hasGeneralAccess(user, permissionKey)
      }

      // 2. custom_permissions exists but is invalid (undefined).
      if (hasCustomPermissionsPayload(user)) return false

      // 3. Fallback to legacy roles only when custom payload is absent.
      if (permissionKey === 'administracao_usuarios') {
        return this.$auth.check(['Administrador', 'Patrimônio'])
      }

      if (permissionKey === 'administracao_niveis_acesso') {
        return this.$auth.check(['Administrador'])
      }

      if (permissionKey === 'visualizar_relatorios') {
        return this.$auth.check(['Administrador'])
      }

      return false
    },
    $hasGranularPermission (category, action) {
      const user = this.$auth.user()
      if (!user) return false

      // 1. Prioritize custom RBAC payload when present (fail-closed).
      if (shouldUseCustomPermissions(user)) {
        return hasGranularPermission(user, category, action)
      }

      // 2. custom_permissions exists but is invalid (undefined).
      if (hasCustomPermissionsPayload(user)) return false

      // 3. Fallback to legacy roles only when custom payload is absent.
      if (this.$auth.check(['Administrador', 'Diretoria', 'Patrimônio'])) {
        return true
      }

      if (this.$auth.check('Operacional')) {
        // Legacy Operacional behavior
        if (category === 'valor') return false
        if (action === 'view') return true
        return false
      }

      console.warn('Granular Permission Denied (No Role Match):', category, action, user)
      return false
    },
    $hasUserRestrictionFlag (flag) {
      const user = this.$auth.user()
      return getUserRestrictionFlag(user, flag)
    },
    $primeUserRestrictions () {
      const user = this.$auth.user()
      return primeUserRestrictions(user)
    }
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<div id="app"><router-view></router-view></div>'
})

// Cordova device ready
Vue.cordova.on('deviceready', () => {
  // Geolocation
  Vue.cordova.geolocation.watchPosition((position) => {
    const coordsAtuais = store.getters['utils/coords']

    if (position.coords.latitude !== coordsAtuais.latitude || position.coords.longitude !== coordsAtuais.longitude) {
      store.dispatch('utils/setCoords', position)
    }
  }, () => {
  }, {
    enableHighAccuracy: true
  })

  // Push init
  const iosSettings = {
    kOSSettingsKeyAutoPrompt: true
  }
  window.plugins.OneSignal
    .startInit('987a10c1-e7c3-4081-8c17-dadfa9705f2b')
    .iOSSettings(iosSettings)
    .inFocusDisplaying(window.plugins.OneSignal.OSInFocusDisplayOption.Notification)
    .endInit()
})



// WEBPACK FOOTER //
// ./src/main.js